const pureEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const date = /\\d{2}(\\.|-)\\d{2}(\\.)\\d{4}/;
const time = /^(?:[0-1]?[0-9]|2[0-3])(?::[0-5][0-9])?$/;

export const regexValidators = {
    phone: '[\+][0-9() ]{7,}$',
    email: pureEmail,
    date,
    time
};
